import { cn } from '@/lib/utils';
import { VariantProps, cva } from 'class-variance-authority'
import { HTMLAttributes, forwardRef, } from 'react'


const alertVariants = cva('bp-2 border rounded text-sm font-medium', {
    variants: {
        variant: {
            info: "border-blue-600 bg-blue-50 text-blue-600",
            error: "border-red-600 bg-red-50 text-red-600",
            warning: "border-yellow-800 bg-yellow-50 text-yellow-800",
            success: "border-green-600 bg-green-50 text-green-600",
            grey: "border-grey-100 dark:border-grey-700 bg-grey-50 dark:bg-grey-600 text-grey-600 "
        },
        size: {
            primary: 'px-4 py-2',
        }
    },
    defaultVariants: {
        variant: 'info',
        size: 'primary'
    }
})

interface Props extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof alertVariants> {

}

const Alert = forwardRef<HTMLDivElement, Props>(({ className, size, variant, children, ...props }) => {
    return (
        <div className={cn(alertVariants({ className, size, variant }))} {...props}>
            {children}
        </div>
    )
})

// eslint-disable-next-line react-refresh/only-export-components
export { Alert, alertVariants }